import secureApi from '../../utils/secureApi';
import imageCompression from 'browser-image-compression';

export async function uploadNewsArticleImage(file: File): Promise<string> {
  const compressedFile = await imageCompression(file, {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  });

  const now = new Date();
  const dd = String(now.getDate()).padStart(2, '0');
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const yyyy = now.getFullYear();
  const ext = compressedFile.type.split('/')[1] || 'jpg';
  const fileName = `news_${Date.now()}.${ext}`;
  const context = `news-article/${dd}-${mm}-${yyyy}`;

  const presignRes = await secureApi.post<any>(
    `/api/v1/general/presigned-url`,
    {
      fileName,
      contentType: compressedFile.type,
      context,
    }
  );

  // Handle API response structure: may be wrapped in { statusCode, data: {...} } or direct
  const responseData = (presignRes as any)?.data || presignRes;
  const presignedUrl = responseData?.presignedUrl;
  const s3Key = responseData?.key;
  if (!presignedUrl || !s3Key) {
    throw new Error('Failed to get presigned URL');
  }

  const uploadRes = await fetch(presignedUrl, {
    method: 'PUT',
    headers: { 'Content-Type': compressedFile.type },
    body: compressedFile,
  });

  if (!uploadRes.ok) {
    throw new Error('Failed to upload image to S3');
  }

  return s3Key;
}
